import { Fragment } from 'react';
import {
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbDivider,
  BreadcrumbItem as FluentBreadcrumbItem,
  makeStyles,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { headingStyle } from '../theme/headingTheme';
import type { BreadcrumbItem } from './breadcrumbTrail';

const useStyles = makeStyles({
  current: {
    color: headingStyle.color,
    letterSpacing: headingStyle.letterSpacing,
  },
});

interface BreadcrumbsProps {
  trail: BreadcrumbItem[];
  onNavigate: (path: string) => void;
}

const Breadcrumbs = ({ trail, onNavigate }: BreadcrumbsProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <Breadcrumb
      data-layout-context=""
      aria-label={t('breadcrumb', 'Breadcrumb')}
      size="large"
    >
      {trail.map((item, index) => {
        const current = index === trail.length - 1;
        const path = item.path;
        return (
          <Fragment key={`${index}-${item.label}`}>
            <FluentBreadcrumbItem>
              <BreadcrumbButton
                current={current}
                className={current ? styles.current : undefined}
                onClick={!current && path ? () => onNavigate(path) : undefined}
              >
                {item.label}
              </BreadcrumbButton>
            </FluentBreadcrumbItem>
            {!current && <BreadcrumbDivider />}
          </Fragment>
        );
      })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
